import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../../shared/axios/axios';
import newAxios from '../../shared/axios/new-api-axios';

import { Button, Tooltip, List, Card, Tabs, Divider, Collapse } from 'antd';

const { Panel } = Collapse;

import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

import SendFilesNavigator from './send-files-navigator';
import SelectedFilesList from '../selected-files-list';

import SendFileForm from '../ncFileManager/fileManager/client/components/send-file-form/send-file-form';

import { fileOwnerTypes } from '../../shared/constants/enums';

import * as actions from '../ncFileManager/store/actions';
import * as sharedActions from '../../shared/store/actions';

import './send-files-selector.less';

import withErrorHandler from '../../hoc/withErrorHandler';

import { hot } from 'react-hot-loader/root';
import { cloneDeep } from 'lodash';
import { isGuid, validateGuid } from '../../shared/utils';

let root;

class SendFilesSelector extends Component {
  state = {
    selectedFiles: [],
    masterCertificateId: null,
    verifyFolderStructureLoading: true,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!this._initialized) {
      root = this.props.rootContainer;

      this.runFolderStructureTasks();
    }
  }

  async runFolderStructureTasks() {
    let validationParams = {
      insuredId: validateGuid(window['ncFileManager']['insuredId']),
      policyId: validateGuid(window['ncFileManager']['policyId']),
      noteId: validateGuid(window['ncFileManager']['noteId']),
      taskId: validateGuid(window['ncFileManager']['taskId']),
      agencyId: validateGuid(window['ncFileManager']['agencyId']),
      agentId: validateGuid(window['ncFileManager']['agentId']),
      opportunityId: validateGuid(window['ncFileManager']['opportunityId']),
      claimId: validateGuid(window['ncFileManager']['claimId']),
      serviceRequestId: validateGuid(window['ncFileManager']['serviceRequestId']),
      ownerType: window['ncFileManager']['ownerType'],
      isOnCertsPage: window['ncFileManager']['isOnCertsPage'],
      currentFullURL: window.location.href,
    };

    const tasks = [];

    if (isGuid(window['ncFileManager']['agencyId'])) {
      tasks.push(() => this.props.verifyFolderStructure({ ...validationParams, ownerType: fileOwnerTypes.Agency }));
    }

    if (isGuid(window['ncFileManager']['agentId'])) {
      tasks.push(() => this.props.verifyFolderStructure({ ...validationParams, ownerType: fileOwnerTypes.Agent }));
    }

    if (isGuid(window['ncFileManager']['insuredId'])) {
      tasks.push(() => this.props.verifyFolderStructure({ ...validationParams, ownerType: fileOwnerTypes.Insured }));
    }

    if (isGuid(window['ncFileManager']['policyId'])) {
      tasks.push(() => this.props.verifyFolderStructure({ ...validationParams, ownerType: fileOwnerTypes.Policy }));
    }

    for (const task of tasks) {
      await task();
    }

    this.props.getPermissions();
    this.props.getFilesControlConfiguration(true);
    this.getFilesInformation();

    this.setState({ verifyFolderStructureLoading: false });
  }

  componentWillUnmount() {
    this._initialized = false;
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleCertificateChanged();

    if (!this._initialized && !this.props?.selectedFilesInfoLoading && this.props?.selectedFilesInfo) {
      //this will be run once or on change certificate Id
      this._initialized = true;

      this.handleSelectFilesToSend(this.props.selectedFilesInfo);
    }
  }

  getFilesInformation = (skipSelectedFiles = false) => {
    const fileIds = !skipSelectedFiles ? window?.ncFileManager?.selectedFileIds : [];
    const receiptId = window?.ncFileManager?.receiptId;
    const certificateId = window?.ncFileManager?.masterCertificateId;

    if (fileIds?.length >= 0 || receiptId || certificateId) {
      this.props.getFilesInfo(
        fileIds,
        receiptId,
        window?.ncFileManager?.receiptIsCustomerAccountStatement,
        window?.ncFileManager?.isReceipt,
        certificateId,
      );

      if (isGuid(certificateId)) {
        this.setState({ masterCertificateId: certificateId });
      }
    }
  };

  sendCertificateFiles = () => {
    if (isGuid(this.state.masterCertificateId) && this.state.selectedFiles) {
      this.props.sendCertificateFiles({
        certificateId: this.state.masterCertificateId,
        fileIds: this.state.selectedFiles.map((f) => f.id),
      });
    }
  };

  handleCertificateChanged = () => {
    const certificateId = window?.ncFileManager?.masterCertificateId;

    if (certificateId && certificateId != this.state.masterCertificateId) {
      //clear selection if certificate changed
      this.setState({ selectedFiles: [], masterCertificateId: certificateId }, () => {
        this._initialized = false;
        this.getFilesInformation(true);
      });
    }
  };

  triggerFilesSelectedCallback = (fileIds) => {
    if (window.ncFileManager && window.ncFileManager.filesSelectedCallback) {
      window.ncFileManager.filesSelectedCallback(fileIds);
    }
    this.sendCertificateFiles();
  };

  handleSelectFilesToSend = (items) => {
    if (items && items.length) {
      const files = cloneDeep(this.state.selectedFiles);

      let order = Math.max(...files.map((o) => o.order)) || 0;

      items.forEach((item) => {
        if (files.findIndex((f) => f.id === item.id) < 0) {
          if (order === -Infinity) {
            order = -1; // -1 so that we start ordering files from 0
          }

          item.order = order + 1;

          files.push(item);
        }
      });

      const sortedFiles = files.sort((a, b) => {
        if (a.order < b.order) {
          return -1;
        }

        if (a.order > b.order) {
          return 1;
        }

        return 0;
      });

      this.setState({ selectedFiles: sortedFiles }, () => {
        this.triggerFilesSelectedCallback(
          sortedFiles.map((f) => {
            return { id: f.id, order: f.order };
          }),
        );
      });
    }
  };

  handleRemoveSelectedFile = (item) => {
    const items = cloneDeep(this.state.selectedFiles);
    const receipt = window?.ncFileManager?.receiptId;

    const index = items.findIndex((f) => f.id === item.id && item.id !== receipt);
    if (index > -1) {
      items.splice(index, 1);

      const sortedFiles = items.sort((a, b) => {
        if (a.order < b.order) {
          return -1;
        }

        if (a.order > b.order) {
          return 1;
        }

        return 0;
      });

      sortedFiles.forEach((file, index) => {
        file.order = index;
      });

      this.setState({ selectedFiles: sortedFiles }, () => {
        this.triggerFilesSelectedCallback(
          sortedFiles.map((f) => {
            return { id: f.id, order: f.order };
          }),
        );
      });
    }
  };

  handleClearSelectedFiles = () => {
    this.setState({ selectedFiles: [] }, () => {
      this.triggerFilesSelectedCallback([]);
    });
  };

  render() {
    const { rootContainer, selectedFilesInfoLoading, permissions, permissionsLoading, controlConfiguration, controlConfigurationLoading } =
      this.props;

    const { verifyFolderStructureLoading } = this.state;

    const isOnCertsPage = window['ncFileManager']['isOnCertsPage'];

    const tabItems = [
      ...(window['ncFileManager']['policyId']
        ? [
            {
              key: '1',
              label: 'Policy Files',
              children: (
                <SendFilesNavigator
                  rootContainer={rootContainer}
                  selectFilesToSend={this.handleSelectFilesToSend}
                  permissions={permissions}
                  controlConfiguration={controlConfiguration}
                  ownerTypeOverride={fileOwnerTypes.Policy}
                  isOnCertsPage={isOnCertsPage}
                />
              ),
            },
          ]
        : []),
      ...(window['ncFileManager']['insuredId']
        ? [
            {
              key: '2',
              label: 'Insured Files',
              children: (
                <SendFilesNavigator
                  rootContainer={rootContainer}
                  selectFilesToSend={this.handleSelectFilesToSend}
                  permissions={permissions}
                  controlConfiguration={controlConfiguration}
                  isOnCertsPage={isOnCertsPage}
                />
              ),
            },
          ]
        : []),
      ...(window['ncFileManager']['agentId']
        ? [
            {
              key: '3',
              label: 'Agent Files',
              children: (
                <SendFilesNavigator
                  rootContainer={rootContainer}
                  selectFilesToSend={this.handleSelectFilesToSend}
                  permissions={permissions}
                  controlConfiguration={controlConfiguration}
                  ownerTypeOverride={fileOwnerTypes.Agent}
                  isOnCertsPage={isOnCertsPage}
                />
              ),
            },
          ]
        : []),
      ...(window['ncFileManager']['agencyId']
        ? [
            {
              key: '4',
              label: 'Agency Files',
              children: (
                <SendFilesNavigator
                  rootContainer={rootContainer}
                  selectFilesToSend={this.handleSelectFilesToSend}
                  permissions={permissions}
                  controlConfiguration={controlConfiguration}
                  ownerTypeOverride={fileOwnerTypes.Agency}
                  isOnCertsPage={isOnCertsPage}
                />
              ),
            },
          ]
        : []),
    ];

    const content = (
      <Card
        bordered={false}
        loading={permissionsLoading || selectedFilesInfoLoading || controlConfigurationLoading || verifyFolderStructureLoading}
        style={{ height: '100%', margin: '0' }}
        bodyStyle={isOnCertsPage ? { padding: '0px' } : { padding: '10px' }}
      >
        {!permissionsLoading && !selectedFilesInfoLoading && !controlConfigurationLoading && !verifyFolderStructureLoading ? (
          <Collapse activeKey={1} className="more-files-collapse">
            <Panel header="Select files" key="1">
              <Tabs defaultActiveKey="1" items={tabItems} />
            </Panel>
          </Collapse>
        ) : null}

        {this.state.selectedFiles.length ? (
          <>
            <SelectedFilesList
              selectedFiles={this.state.selectedFiles}
              onRemoveFile={this.handleRemoveSelectedFile}
              onClearFiles={this.handleClearSelectedFiles}
              rootContainer={rootContainer}
              masterCertificateId={this.state.masterCertificateId}
              receiptId={window?.ncFileManager?.receiptId}
            />

            <Divider type="horizontal" />
          </>
        ) : null}

        {!window['ncFileManager']['hideSendForm'] && permissions ? (
          <div>
            <SendFileForm
              rootContainer={rootContainer}
              inlineRenderMode={true}
              selectedFiles={this.state.selectedFiles ? this.state.selectedFiles : []}
              receiptId={window['ncFileManager']['receiptId']}
              receiptIsCustomerAccountStatement={window['ncFileManager']['receiptIsCustomerAccountStatement']}
              insuredId={window['ncFileManager']['insuredId']}
              sendFormCallback={this.props.sendFormCallback}
              isReceipt={window['ncFileManager']['isReceipt']}
              isStatement={window['ncFileManager']['isStatement']}
              isOnCertsPage={isOnCertsPage}
              isInsuredSummary={window['ncFileManager']['isInsuredSummary']}
            />
          </div>
        ) : null}
      </Card>
    );

    return content;
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.permissions.permissions,
    error: state.permissions.error,
    permissionsLoading: state.permissions.loading,
    selectedFilesInfo: state.sendFiles.selectedFilesInfo,
    selectedFilesInfoLoading: state.sendFiles.selectedFilesInfoLoading,
    controlConfiguration: state.files.controlConfiguration,
    controlConfigurationLoading: state.files.controlConfigurationLoading,
    certificateFilesSuccess: state.sendFiles.certificateFiles,
    certificateFilesLoading: state.sendFiles.certificateFilesLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPermissions: () => dispatch(sharedActions.getPermissions()),
    getFilesInfo: (fileIds, receiptId, receiptIsCustomerAccountStatement, isReceipt, masterCertificateId) =>
      dispatch(actions.getFilesInfo(fileIds, receiptId, receiptIsCustomerAccountStatement, isReceipt, masterCertificateId)),
    getFilesControlConfiguration: (isSendFiles) => dispatch(actions.getFilesControlConfiguration(isSendFiles)),
    sendCertificateFiles: (params) => dispatch(actions.sendCertificateFiles(params)),
    verifyFolderStructure: (params) => dispatch(actions.verifyFolderStructure(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(hot(withErrorHandler(SendFilesSelector, axios, root, newAxios)));
